import { themeVars } from './theme/vars';
import { style } from './layer.css';

export const externalLink = style({
  color: themeVars.link.idle,

  ':hover': {
    textDecoration: 'underline',
  },
});
